import { toast } from "sonner";
import api from "@/lib/api";

/**
 * Trigger a soft-delete on the backend and offer an Undo toast that calls
 * the restore endpoint. The item is preserved server-side for 30 days.
 *
 * @param {object} o
 * @param {"resume"|"letter"|"job"} o.kind — Item kind (matches trash router)
 * @param {string}                  o.id   — Item id
 * @param {() => Promise<any>}      o.apiDelete    — Actual DELETE call (soft-delete)
 * @param {() => void}              o.optimisticHide — Hide the item locally NOW
 * @param {() => void}              o.restore     — Put the item back locally
 * @param {object}                  o.labels      — { success, undone, undo, error }
 * @param {number}                  [o.duration]  — Toast duration in ms (default 15 s)
 */
export async function softDeleteWithUndo({ kind, id, apiDelete, optimisticHide, restore, labels, duration = 15000 }) {
  optimisticHide();
  try {
    await apiDelete();
  } catch (e) {
    toast.error(e?.response?.data?.detail || labels.error);
    restore();
    return;
  }

  toast.success(labels.success, {
    duration,
    action: {
      label: labels.undo,
      onClick: async () => {
        try {
          await api.post(`/trash/${kind}/${id}/restore`);
          restore();
          toast.info(labels.undone);
        } catch (e) {
          toast.error(e?.response?.data?.detail || labels.error);
        }
      },
    },
  });
}
